/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

/** Map a document version title to the ordered DynaMed sections to show along with it. */
export type DynamedSectionMapping = {
  filename: string;
  name: string;
};

export type DynamedGuideMapping = {
  sections: DynamedSectionMapping[];
};

const goutSections: DynamedSectionMapping[] = [
  { name: 'Overview and Recommendations', filename: 'gout-overview.html' },
  { name: 'Background Information', filename: 'gout-background.html' },
  { name: 'History and Physical', filename: 'gout-history.html' },
  { name: 'Diagnosis', filename: 'gout-diagnosis.html' },
  { name: 'Management', filename: 'gout-management.html' },
  { name: 'Complications', filename: 'gout-complications.html' },
  { name: 'Prognosis', filename: 'gout-prognosis.html' },
  { name: 'Prevention and Screening', filename: 'gout-prevention-and-screening.html' },
  { name: 'Guidelines and Resources', filename: 'gout-guidelines.html' },
  { name: 'Patient Information', filename: 'gout-patient.html' },
  { name: 'References', filename: 'gout-references.html' },
];

export const guideToTestDataMapping: Record<string, DynamedGuideMapping> = {
  'Gout Referral Guide': {
    sections: goutSections,
  },
  'Gout Guide': {
    sections: goutSections,
  },
};
